// Disparo da conversão de cadastro de oficina no Google Ads.
// O tag base (gtag.js) é carregado no index.html. A conversão só é contabilizada
// quando o rótulo (parte após a barra, ex.: 'AbC-dEfG') estiver definido em
// VITE_GOOGLE_ADS_SIGNUP_LABEL; sem ele, dispara apenas um evento de sinal.

const ADS_ID = (import.meta.env.VITE_GOOGLE_ADS_ID as string | undefined) || 'AW-18264294604';
// Rótulo da ação "Conta criada" (criada em 2026-07-25). Valor público — vai
// no bundle de qualquer forma, como o ADS_ID; o env só permite override.
const SIGNUP_LABEL =
  (import.meta.env.VITE_GOOGLE_ADS_SIGNUP_LABEL as string | undefined) || '905sCL-MytYcEMyJjIVE';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/** Chamar uma única vez, logo após a oficina ser criada com sucesso. */
export function trackSignupConversion(): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  if (SIGNUP_LABEL) {
    window.gtag('event', 'conversion', {
      send_to: `${ADS_ID}/${SIGNUP_LABEL}`,
    });
  } else {
    // Sinal de cadastro concluído enquanto o rótulo de conversão não é configurado.
    window.gtag('event', 'sign_up', { method: 'web_admin' });
  }
}
